import { Button, TDeviceType } from '@cian/ui-kit';
import * as styles from './styles.css';
import { clsx } from 'clsx';

interface IHeaderProps {
  onClickBtn: VoidFunction;
  btnText: string;
  device: TDeviceType;
}

export const Header: React.FC<IHeaderProps> = ({ onClickBtn, btnText, device }) => {
  return (
    <div className={clsx(styles['container'], styles[device])}>
      <div className={styles['logo']} />
      <div className={styles['btn']}>
        <Button size={device === 'phone' ? 'XS' : 'M'} fullWidth theme="stroke_primary" onClick={onClickBtn}>
          {btnText}
        </Button>
      </div>
    </div>
  );
};
